module.exports = __webpack_public_path__ + "static/media/12.122.383e0c3d.webp";